html {
  overflow-y: auto;
}
body {
  margin: 0;
  padding: 8px 12px;
  min-width: unset;
  min-height: unset;
}
.empty-preview {
  color: #aaa;
  font-style: italic;
}
